function p(u){let r=new Set,e;return {when(t,n){return r.add([t,n]),this},otherwise(t){return e=t,this},run(){for(let[t,n]of r)if(t(u))return n(u);if(typeof e!="function")throw new Error("Math case miss default handler or is not a function");return e(u)}}}

export { p as a };
